import { Box, BoxProps } from "@mui/material";
import { Iconify, PaymentMethod } from "..";
import { assetUrl } from "../utils";
import { ReactNode } from "react";

export const CARD_PAYMENT_METHOD: PaymentMethod = {
  name: "CARD",
  currency: "USD",
  label: "USD",
  icon: <Iconify icon="solar:card-outline" fontSize="1.5rem" />,
  suffix: <>$</>,
};

export const DEFAULT_CRYPTO_METHODS: PaymentMethod[] = [
  {
    name: "USDT",
    currency: "USDT",
    label: "USDT",
    decimal: 6,
    icon: (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/usdt-icon.svg")}
        alt="usdt"
      />
    ),
  },
  {
    name: "BTC",
    currency: "WBTC",
    label: "Bitcoin",
    chainId: "BTC",
    decimal: 8,
    icon: <Iconify icon="logos:bitcoin" fontSize="1.5rem" />,
  },
  {
    name: "ETH",
    currency: "ETH",
    label: "Ethereum",
    chainId: 1,
    decimal: 18,
    icon: (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/eth-icon-dark.svg")}
        alt="eth"
      />
    ),
  },
  {
    name: "USDC",
    currency: "USDC",
    label: "USDC",
    decimal: 6,
    icon: (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        src={assetUrl("payment/usdc-icon.svg")}
        alt="usdt"
      />
    ),
  },
  {
    name: "DAI",
    currency: "DAI",
    label: "DAI",
    chainId: 100,
    decimal: 18,
    icon: (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        src={assetUrl("payment/dai.png")}
        alt="dai"
      />
    ),
  },
  {
    name: "MATIC",
    currency: "MATIC",
    label: "MATIC",
    chainId: 137,
    decimal: 18,
    icon: <Iconify icon="cryptocurrency-color:matic" fontSize="1.5rem" />,
  },
];

export const CARD_CRYPTO_ADDRESSES: PaymentMethod[] = [
  {
    name: "USDT",
    currency: "USDT",
    label: "USDT",
    decimal: 6,
    icon: (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/usdt-icon.svg")}
        alt="usdt"
      />
    ),
    color: "#26A17B",
  },
  {
    name: "WBTC",
    currency: "WBTC",
    label: "Bitcoin",
    chainId: "BTC",
    decimal: 8,
    icon: <Iconify icon="logos:bitcoin" fontSize="1.5rem" />,
    color: "#F2911B",
  },
  {
    name: "ETH",
    currency: "ETH",
    label: "Ethereum",
    chainId: 1,
    decimal: 18,
    icon: (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/eth-icon-dark.svg")}
        alt="eth"
      />
    ),
    color: "#0c0c0c",
  },
  {
    name: "WETH",
    currency: "WETH",
    label: "Wrapped Ethereum",
    decimal: 18,
    icon: (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/weth-icon.svg")}
        alt="weth"
      />
    ),
    color: "#d62f74",
  },
  {
    name: "USDC",
    currency: "USDC",
    label: "USDC",
    decimal: 6,
    icon: (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        src={assetUrl("payment/usdc-icon.svg")}
        alt="usdt"
      />
    ),
    color: "#2775ca",
  },
];

export const ASSET_MEDIA: Record<
  string,
  { icon: (props?: BoxProps) => ReactNode; color: string }
> = {
  USDT: {
    icon: (props?: BoxProps) => (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/usdt-icon.svg")}
        alt="usdt"
        {...props}
      />
    ),
    color: "#26A17B",
  },

  BTC: {
    icon: (props?: BoxProps) => (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/btc-icon.svg")}
        alt="btc"
        {...props}
      />
    ),
    color: "#FF8D00",
  },
  WBTC: {
    icon: (props?: BoxProps) => (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/btc-icon.svg")}
        alt="btc"
        {...props}
      />
    ),

    color: "#FF8D00",
  },
  ETH: {
    icon: (props?: BoxProps) => (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/eth-icon-dark.svg")}
        alt="eth"
        {...props}
      />
    ),
    color: "#0c0c0c",
  },
  WETH: {
    icon: (props?: BoxProps) => (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        height="1.2rem"
        src={assetUrl("payment/weth-icon.svg")}
        alt="weth"
        {...props}
      />
    ),
    color: "#d62f74",
  },
  USDC: {
    icon: (props?: BoxProps) => (
      <Box
        width="1.3rem"
        minWidth="1.3rem"
        component="img"
        src={assetUrl("payment/usdc-icon.svg")}
        alt="usdt"
        {...props}
      />
    ),
    color: "#2775ca",
  },
};
